/**************************************************
 * Nombre:       Tarjeta_Encontraras
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Encontraras = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: item.gradiente,
                pt: 6,
                px: 3
            }}
        >

            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.icono} alt={item.nombre} width={item.largo ? item.largo : 30} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{color: '#262626', fontSize: 16, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{
                    color: '#545454',
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: 'Inter',
                    height: 110
                }}>{item.descripcion}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <img src={item.img} width={'100%'} height={'auto'}/>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Encontraras